// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-container {
  width: 100%;
  position: absolute;
  bottom: 12px;
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  min-height: 40px;
  max-height: 140px;
}
.bottom-container .minimal-card {
  background-color: var(--background);
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  overflow: hidden;
  border-radius: 8px;
}
.bottom-container .minimal-card .card-close {
  position: absolute;
  top: 8px;
  left: 20px;
  background-color: rgba(1, 1, 1, 0.6);
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.bottom-container .minimal-card .card-close ion-icon {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  margin: auto;
  color: white;
}
.bottom-container .minimal-card .card-cover {
  width: 33%;
  object-fit: cover;
  object-position: center;
}
.bottom-container .minimal-card .card-content {
  display: flex;
  padding: 12px 12px;
  width: 67%;
  flex-direction: column;
  justify-content: space-between;
}
.bottom-container .minimal-card .card-content .card-content-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.bottom-container .minimal-card .card-content .card-content-header .card-content-header-buttons {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
.bottom-container .minimal-card .card-content .card-content-header .card-content-header-buttons ion-icon {
  font-size: 20px;
  padding: 8px;
}
.bottom-container .minimal-card .card-content .card-content-footer {
  overflow: hidden;
  max-height: 4em;
  line-height: 1em;
}
.bottom-container .minimal-card .card-content .card-content-footer .description {
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/experience-map-card/experience-map-card.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EAEA,aAAA;EAEA,sBAAA;EACA,gBAAA;EACA,iBAAA;AACF;AACE;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AACI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACN;AACM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AACR;AAGI;EACE,UAAA;EACA,iBAAA;EACA,uBAAA;AADN;AAII;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,8BAAA;AAFN;AAIM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAFR;AAIQ;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAFV;AAIU;EACE,eAAA;EACA,YAAA;AAFZ;AAOM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AALR;AAOQ;EACE,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AALV;;AAaA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAVF","sourcesContent":[".bottom-container {\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: 12px;\r\n  padding: 0 12px;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n  -webkit-flex-direction: column;\r\n  flex-direction: column;\r\n  min-height: 40px;\r\n  max-height: 140px;\r\n\r\n  .minimal-card {\r\n    background-color: var(--background);\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n    overflow: hidden;\r\n    border-radius: 8px;\r\n\r\n    .card-close {\r\n      position: absolute;\r\n      top: 8px;\r\n      left: 20px;\r\n      background-color: rgba(1, 1, 1, 0.6);\r\n      border-radius: 50%;\r\n      width: 30px;\r\n      height: 30px;\r\n\r\n      ion-icon {\r\n        position: absolute;\r\n        top: 0px;\r\n        left: 0px;\r\n        bottom: 0px;\r\n        right: 0px;\r\n        margin: auto;\r\n        color: white;\r\n      }\r\n    }\r\n\r\n    .card-cover {\r\n      width: 33%;\r\n      object-fit: cover;\r\n      object-position: center;\r\n    }\r\n\r\n    .card-content {\r\n      display: flex;\r\n      padding: 12px 12px;\r\n      width: 67%;\r\n      flex-direction: column;\r\n      justify-content: space-between;\r\n\r\n      .card-content-header {\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: space-between;\r\n\r\n        .card-content-header-buttons {\r\n          display: flex;\r\n          flex-direction: row;\r\n          justify-content: end;\r\n\r\n          ion-icon {\r\n            font-size: 20px;\r\n            padding: 8px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .card-content-footer {\r\n        overflow: hidden;\r\n        max-height: 4.0em;\r\n        line-height: 1.0em;\r\n\r\n        .description {\r\n          font-size: 14px;\r\n          display: -webkit-box;\r\n          -webkit-line-clamp: 3;\r\n          -webkit-box-orient: vertical;\r\n          overflow: hidden;\r\n        }\r\n\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.description {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
